import { __assign } from "tslib";
import React from 'react';
import Logo from '@wix/da-ds/pkg/Logo';
var LogoWithCoreLevel = function (props) {
    return React.createElement(Logo, __assign({}, props));
};
LogoWithCoreLevel.displayName = 'LogoWithCoreLevel';
export default LogoWithCoreLevel;
//# sourceMappingURL=LogoWithCoreLevel.js.map